import React from 'react';
import { MuiBox } from 'theme/material-ui';
import { isMobileBrowser } from 'lib/browser';
import Svg from 'components/UI/Svg/Svg';
import { IconSize } from 'modules/styles/variables';
import { StyledSmallText, CTAMessage } from './styled';

const CTAWithMessage = () => (
  <CTAMessage>
    <MuiBox width={IconSize.large} height={IconSize.large}>
      <Svg set="downloading" name="cloud-download-outlined" size={IconSize.large} />
    </MuiBox>
    {!isMobileBrowser() ? (
      <StyledSmallText>Hang in there. We're downloading your file.</StyledSmallText>
    ) : null}
  </CTAMessage>
);

export default CTAWithMessage;
